export default "__VITE_ASSET__spzRXNii__"